'use client'

import { cn } from 'app/lib/utils'
import Link from 'components/shared/link'
import { usePathname } from 'next/navigation'
import Logo from 'layout/Images/Logo'
import { useEffect, useState } from 'react'
import { useConfig } from 'components/providers/ConfigProvider'

const LayoutLeftSidebar = ({
    items,
    increaseLeftSidebarWidth,
    addQueryParams,
    showFooterNavLinks = true
}: {
    items: ILeftSidebarItems[]
    increaseLeftSidebarWidth?: boolean
    addQueryParams?: boolean
    showFooterNavLinks?: boolean
}) => {
    const config = useConfig()
    const pathname = usePathname().slice(3)
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)
    }, [])

    if (!mounted) {
        return (
            <div
                className={cn(
                    `shadow-lg hidden lg:flex flex-col !overflow-x-hidden min-h-[100dvh] h-[100dvh] fixed left-0 bottom-0 top-0 navbar_glassmorphism`,
                    increaseLeftSidebarWidth ? 'lg:w-[320px]' : 'lg:w-[280px]'
                )}
            />
        )
    }

    return (
        <div
            className={cn(
                `shadow-lg hidden lg:flex flex-col !overflow-x-hidden min-h-[100dvh] h-[100dvh] fixed left-0 bottom-0 top-0 navbar_glassmorphism`,
                increaseLeftSidebarWidth ? 'lg:w-[320px]' : 'lg:w-[280px]'
            )}
        >
            <div className='flex !overflow-x-hidden h-full w-full min-h-0 flex-col'>
                <div className='shrink-0 pl-5 pt-5 pr-2 backdrop-blur-sm z-[999]'>
                    {config && <Logo config={config} />}
                </div>
                <nav
                    className='z-40 flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto !overflow-x-hidden pl-3 md:pl-4 lg:pl-8 pr-2 pt-4 pb-4'
                    aria-label='Sidebar'
                >
                    {items.map((item, index) => (
                        <Link
                            href={item.href}
                            key={`${item.href}-${index}`}
                            addQueryParams={addQueryParams}
                            className={cn(
                                'px-2 py-3 rounded-lg glassmorphism_hover hover:font-semibold !items-center md:gap-1 lg:gap-2 flex font-light cursor-pointer !transition-all !duration-500 whitespace-nowrap group mr-2.5',
                                pathname === item.href ? 'font-bold glassmorphism rounded-lg' : ''
                            )}
                        >
                            {item.icon}
                            <span>{item.name}</span>
                        </Link>
                    ))}
                </nav>
                {showFooterNavLinks && (
                    <div className='flex shrink-0 flex-col gap-4 !overflow-x-hidden pb-8 md:pl-7 lg:pl-10'>
                        {[
                            { href: `/home`, name: 'Home' },
                            { href: `/info/about-us`, name: 'About us' },
                            { href: '/info/contact-us', name: 'Contact Us' }
                        ].map((link, index) => (
                            <Link
                                key={`${link.href}-${index}`}
                                href={link.href}
                                className='hover:font-semibold items-center md:gap-1 lg:gap-2 flex font-light cursor-pointer !transition-all !duration-500 whitespace-nowrap group'
                            >
                                <span>{link.name}</span>
                            </Link>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}

export default LayoutLeftSidebar
